// GENERATE ARRIVED LIST ID

const apiUrl = process.env.REACT_APP_API_URL;

const getPhilippinesDate = () => {
    const options = {
        timeZone: 'Asia/Manila',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
    };

    const formatter = new Intl.DateTimeFormat('en-PH', options);
    return formatter.format(new Date());
};

const generate_Id = () => {
    const datePart = getPhilippinesDate().replaceAll('/', '');
    const randomPart = Math.floor(1000 + Math.random() * 9000);
    return `ALST${datePart}${randomPart}`;
};

export const getArrivedListId = async () => {
    let listId;
    let isUnique = false;

    while (!isUnique) {
        listId = generate_Id();

        try {
            const response = await fetch(`${apiUrl}validation/validate_list_id.php`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ listId }),
            });

            const data = await response.json();
            isUnique = data.unique;
            
        } catch (error) {
            console.error('Error validating list number:', error);
            break;
        }
    }

    return listId;
};